module.exports = __webpack_public_path__ + "static/media/background.177454ab.jpg";